/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Roleentityscope2Inputs */

const en_entity_roleentityscope2 = /** @type {(inputs: Entity_Roleentityscope2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Role Entity Scope`)
};

const de_entity_roleentityscope2 = /** @type {(inputs: Entity_Roleentityscope2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rollen-Geltungsbereich`)
};

/**
* | output |
* | --- |
* | "Role Entity Scope" |
*
* @param {Entity_Roleentityscope2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_roleentityscope2 = /** @type {((inputs?: Entity_Roleentityscope2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Roleentityscope2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_roleentityscope2(inputs)
	return de_entity_roleentityscope2(inputs)
});
export { entity_roleentityscope2 as "entity_roleEntityScope" }